import { createLanguageRegistrar } from "./languageBase";

/** Monarch language definition for PHP. */
const phpDef: Record<string, unknown> = {
  keywords: [
    "abstract",
    "and",
    "array",
    "as",
    "break",
    "callable",
    "case",
    "catch",
    "class",
    "clone",
    "const",
    "continue",
    "declare",
    "default",
    "do",
    "echo",
    "else",
    "elseif",
    "enddeclare",
    "endfor",
    "endforeach",
    "endif",
    "endswitch",
    "endwhile",
    "enum",
    "extends",
    "final",
    "finally",
    "fn",
    "for",
    "foreach",
    "function",
    "global",
    "goto",
    "if",
    "implements",
    "include",
    "include_once",
    "instanceof",
    "insteadof",
    "interface",
    "match",
    "namespace",
    "new",
    "or",
    "print",
    "private",
    "protected",
    "public",
    "readonly",
    "require",
    "require_once",
    "return",
    "static",
    "switch",
    "throw",
    "trait",
    "try",
    "use",
    "var",
    "while",
    "xor",
    "yield",
  ],

  builtinTypes: [
    "int",
    "float",
    "string",
    "bool",
    "array",
    "object",
    "void",
    "never",
    "null",
    "mixed",
    "self",
    "parent",
    "iterable",
    "true",
    "false",
  ],

  tokenizer: {
    root: [
      [/<\?php/, "keyword.php"],
      [/<\?=/, "keyword.php"],
      [/\?>/, "keyword.php"],
      [/\/\/[^\n]*/, "comment.php"],
      [/#[^\n]*/, "comment.php"],
      [/\/\*/, "comment.php", "@blockComment"],
      [/"/, "string.php", "@doubleString"],
      [/'/, "string.php", "@singleString"],
      [/\$[a-z_]\w*/i, "variable.php"],
      [/#\[/, "annotation.php", "@attribute"],
      [/0x[0-9a-f_]+/i, "number.php"],
      [/0b[01_]+/i, "number.php"],
      [/0o[0-7_]+/i, "number.php"],
      [/\d[\d_.]*/, "number.php"],
      [
        /[a-z_]\w*/i,
        {
          cases: {
            "@keywords": "keyword.php",
            "@builtinTypes": "type.identifier.php",
            "@default": "identifier",
          },
        },
      ],
      [/=>|->|::|\?\?|\.\.\.|\?->/, "operator.php"],
      [/[-+*/%=<>!&|^~.]/, "operator.php"],
      [/[{}()[\];,]/, "delimiter"],
      [/\s+/, "white"],
    ],

    doubleString: [
      [/\$[a-z_]\w*/i, "variable.php"],
      [/\{/, "delimiter", "@doubleStringInterp"],
      [/[^\\"$]+/, "string.php"],
      [/\\./, "string.escape.php"],
      [/"/, "string.php", "@pop"],
    ],

    doubleStringInterp: [
      [/\$[a-z_]\w*/i, "variable.php"],
      [/\}/, "delimiter", "@pop"],
      [/./, "string.php"],
    ],

    singleString: [
      [/[^\\']+/, "string.php"],
      [/\\./, "string.escape.php"],
      [/'/, "string.php", "@pop"],
    ],

    blockComment: [
      [/\*\//, "comment.php", "@pop"],
      [/./, "comment.php"],
    ],

    attribute: [
      [/\]/, "annotation.php", "@pop"],
      [/[a-z_]\w*/i, "annotation.php"],
      [/./, "annotation.php"],
    ],
  },
};

/**
 * Registers a Monarch tokenizer for PHP with Monaco.
 */
export const registerPHP = createLanguageRegistrar({ id: "php", extensions: [".php", ".phtml"] }, phpDef);
